import { Loader } from '@progress/kendo-react-indicators';

import type { LoaderOverlayComponent } from './overlay.type';

const LoaderOverlay: LoaderOverlayComponent = function ({ showLoader = true, type = 'infinite-spinner', opacity = 0.75, zIndex = 1, size = 'large' }) {
  return (
    <div
      className="loader-overlay bg-white top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center position-fixed"
      style={{ opacity, zIndex }}
    >
      {showLoader && (
        <Loader
          type={type}
          size={size}
        />
      )}
    </div>
  );
};

export default LoaderOverlay;
